import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, ContactosService, MenuService } from '@app/_services';
import { ContactosenteService } from '@app/_services/contactosente.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-contactos-ente-detalles',
  templateUrl: './contactos-ente-detalles.component.html'
})
export class ContactosEnteDetallesComponent implements OnInit {
  
  form: FormGroup;
  codigo: string;
  idContacto: number;
  isAddMode: boolean;
  loading = false;
  submitted = false;
//hhhhh




  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private contactosService: ContactosenteService,
    private alertService: AlertService,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.menuService.titulo = this.translateService.instant('contactos.contactos');
    
    this.codigo = this.route.snapshot.params['idorg'];
    this.idContacto = this.route.snapshot.params['idDep'];
    console.log('LLega idorg= '+this.codigo + '-- idContacto= '+this.idContacto );

    this.isAddMode = !this.codigo;

    this.form = this.formBuilder.group({
        id: this.idContacto,
        nombre: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required,Validators.email]),
        phone: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')])             
    });

    if (!this.isAddMode) {
        this.contactosService.GetContacto(this.idContacto)
            .pipe()
            .subscribe((result) => {
              console.log('Llega:');
              console.log(result);
              this.form = this.formBuilder.group({
                id: this.idContacto,
                nombre: new FormControl(result.data[0].contacto, [Validators.required]),
                email: new FormControl(result.data[0].email, [Validators.email]),
                phone: new FormControl(result.data[0].phone, [Validators.required, Validators.pattern('^[0-9]*$')])             
              });
            });
    }
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
        // TODO This as a workaround.
        this.menuService.titulo = this.translateService.instant('contactos.contactos');
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }

    this.loading = true;
    if (this.isAddMode) { 
        //this.crearContacto();
    } else {
        this.updateContacto();
    }
  }



  private updateContacto() {
    console.log('ACTUALIZO:'+this.idContacto);
    this.contactosService.update(this.form.value,this.idContacto)
        .pipe(first())
        .subscribe((result) => {
            if(!result.error) {
              this.alertService.success(this.translateService.instant('botones.editadocorrectamente'), { keepAfterRouteChange: true });
              this.router.navigate(['contactos-ente/', {idorg:this.codigo}]);
            } else {
              this.alertService.error(this.translateService.instant('contactos.erroreditar'));
              this.loading = false;
            }
        });
  }

  
    
}
